export const GET_WEBSITE_LOGO_REQUEST = 'GET_WEBSITE_LOGO_REQUEST';
export const GET_WEBSITE_LOGO_SUCCESS = 'GET_WEBSITE_LOGO_SUCCESS';
export const GET_WEBSITE_LOGO_FAILURE = 'GET_WEBSITE_LOGO_FAILURE';
